import React, {useMemo} from "react";
import {Bar, BarChart, ResponsiveContainer, XAxis, YAxis} from "recharts";

export default function SkeletonBarChart() {
    const data = useMemo(() => {
        const result = [];
        for (let i = 0; i < 10; i++) {
            result.push({
                name: `Label ${i + 1}`,
                value: Math.floor(Math.random() * 1000),
            });
        }
        return result;
    }, []);

    return (
        <ResponsiveContainer height="100%">
            <BarChart data={data}>
                <XAxis dataKey="name" tick={false} height={1} />
                <YAxis tick={false} width={1} />
                <Bar
                    dataKey={"value"}
                    isAnimationActive={false}
                    className="skeleton-svg"
                />
            </BarChart>
        </ResponsiveContainer>
    );
}
